import { Property } from "./interfaces";

export const codTecnologiaSalud: Property = {
    title: "Código de Tecnología de Salud",
    type: "string"
}